import React from 'react';
import { faUserCheck } from '@fortawesome/pro-regular-svg-icons/faUserCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function UserCheckRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faUserCheck} {...props} />;
}
